import { openMailto } from "@/utils/mailto";
import Button from "../components/button";
import Hero from "../components/hero";
import heroImage from "@assets/images/gas-services-hero.svg";
import gasSolution from "@assets/images/Frame 1618869509.png";
import arrowRightIconBold from "@assets/icons/arrow-right-line-black-bold.svg";
import arrowRightIcon from "@assets/icons/arrow-narrow-right-gray.svg";
import safeIcon from "@assets/icons/safeIcon.svg";
import { gasServices, gasSolutions } from "../data";
import { Link } from "react-router-dom";
import Help from "../components/help";

const heroData = {
  title: "Safe, Reliable, and Fully Certified Gas Solutions Across the UAE",
  description:
    "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), we design, install, and manage advanced gas systems for residential, commercial, and industrial clients combining safety, efficiency, and smart technology in every connection. ",
  image: heroImage,
  buttonText: "Request Residential Service",
  buttonOnclick: () =>
    openMailto({
      subject: "Residential Gas Service Request",
      body: "Hello,\n\nI would like to request gas service.\n\nService Type:\nAddress:\nContact Person:\nPhone:\n",
    }),
  footerText:
    "We provides safe, certified, and efficient gas connections across the UAE delivered and activated quickly by our licensed technicians",
  footerButtonText: "Talk to Our Team",
  footerButtonOnclick: () => openMailto({ subject: "Gas Services Inquiry" }),
  footerIcon: <img src={safeIcon} alt="" className="w-7 h-7" />,
};

const GasServices = () => {
  return (
    <div className="bg-white">
      <Hero data={heroData} />

      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto">
          <div className="flex flex-col items-start justify-between md:gap-5 lg:gap-10 lg:flex-row">
            <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[56px] font-bold max-w-[900px]">
              We deliver end to end gas supply and support from network design
              to daily operation.
            </h2>

            <Button
              title="View all services"
              className="mt-3"
              onClick={() =>
                openMailto({
                  subject: "Gas Services Inquiry",
                  body: "Hello,\n\nI would like to learn more about your gas services.\n\nThank you.",
                })
              }
            />
          </div>

          <div className="grid gap-4 mt-16 md:grid-cols-2 xl:grid-cols-3 md:gap-6">
            {gasServices.map((data, index) => (
              <article
                key={index}
                className="bg-white p-4 md:p-6 rounded-[12px] md:rounded-[24px]"
              >
                <span className="bg-gis-red text-white rounded-md text-xs px-3 py-1.5 inline-block">
                  {data.type}
                </span>
                <h4 className="text-sm md:text-lg lg:text-xl font-semibold text-[#1C1C1C] mt-4">
                  {data.title}
                </h4>
                <p className="mt-4 md:mt-6 text-[14px] md:text-sm text-[#0A0E2EBF]">
                  {data.desc}
                </p>
                <Link
                  to={data.link}
                  className="flex items-center text-[#090D2C] gap-3 mt-10 text-sm font-medium tracking-tighter md:text-lg lg:text-xl"
                >
                  Explore more
                  <img
                    src={arrowRightIconBold}
                    alt="arrow right icon"
                    className="size-5 md:size-8"
                  />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CUSTOM SOLUTION FOR SPECIAL NEEDS */}
      <section className="py-10 md:py-20 xl:py-[120px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto flex gap-5 md:gap-10 flex-col xl:flex-row justify-between">
          <div className="xl:max-w-[673px]">
            <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold">
              Custom Gas Solutions for Specialized Needs
            </h2>
            <p className="mt-5 text-[14px] md:text-base lg:text-lg text-[#62636C]">
              In addition to standard supply services, we also offer tailored
              gas solutions for developers, property managers, and large
              infrastructure projects.
            </p>

            <div className="grid gap-4 mt-6 md:grid-cols-2 xl:grid-cols-1">
              {gasSolutions.map((data, index) => (
                <article
                  key={index}
                  className="bg-white border border-[#62636C40] p-4 md:p-8 flex items-center justify-between gap-5 rounded-lg"
                >
                  <div>
                    <h3 className="text-[#090D2C] font-semibold text-sm md:text-base lg:text-xl">
                      {data.title}
                    </h3>
                    <p className="mt-3 text-[14px] md:text-xs lg:text-base text-[#0A0E2EBF]">
                      {data.desc}
                    </p>
                  </div>
                  <img
                    src={arrowRightIcon}
                    alt="arrow right icon"
                    className="size-4 md:size-6"
                  />
                </article>
              ))}
            </div>
          </div>
          <img
            src={gasSolution}
            alt="gas solution image"
            className="lg:max-w-[615px] h-full"
          />
        </div>
      </section>

      <section className="pt-16 md:pt-20 lg:pt-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto md:px-24">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold">
            Certified. Regulated. Compliant.
          </h2>
          <p className="text-xs md:text-sm lg:text-base text-[#62636C] mt-2 md:mt-5">
            GAZ is fully licensed and certified by Dubai Civil Defense and the
            Emirates Authority for Standardization and Metrology (ESMA). All
            connections are tested and commissioned in accordance with UAE Fire
            Safety Code of Practice.
          </p>
        </div>
      </section>

      <Help />
    </div>
  );
};

export default GasServices;
